<section class="section section--finalMsg">
  <div class="container">
    <div class="wrapper">
      <div class="content fadeinright animation-duration-300">
        <form class="form full__height">
          <div class="content__main">
            <article class="mainInfo pb-30">
              <h1 class="pb-10">Proceso finalizado</h1>
              <p>{{ 'Recibirás una llamada nuestra, para confirmar el desembolso del crédito.' | termReplace }}</p>
            </article>

            <article class="finalMsg">
              <div class="finalMsg__illustration">
                <app-contact-img color="color"></app-contact-img>
              </div>

              <div class="finalMsg__text pt-15">
                <h2>¡Gracias!</h2>
                <p>Por escogernos como tu aliado financiero.</p>
              </div>
            </article>
          </div>

          <div class="content__footer">
            <button pButton pRipple type="button" label="Regresar a KrdYa" icon="pi pi-angle-left" iconPos="left" class="p-button-primary p-button-raised p-button-rounded p-button-spaced w-full" (click)="onBackToKrdya()"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
